import ReCAPTCHA from 'react-google-recaptcha';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useRef, useState } from 'react';

import { envVariables } from '@/constants/index';
import { Input, InputWithSelect } from '@/components/ui';
import { InfoCircleRed } from '@/components/SvgComponents';
import { customerPrefixes, serialPrefixes } from '@/constants/base';

import ConditionCheck from '../../ConditionCheck/ConditionCheck';

import styles from '../Checkout.module.scss';

const PersonalInfo = ({ formik, stateHandlers }) => {
  const { t, lang } = useTranslation();
  const captchaRef = useRef(null);
  const [captchaKey, setCaptchaKey] = useState(Date.now());

  const {
    setDeviceModal,
    setNotInListModal,
    setPinModal,
    onChange,
    setTermsModal,
  } = stateHandlers;

  const handleCountryCode = (value) => {
    const maxLength =
      formik.values.countyCode?.name === serialPrefixes[0].name ? 9 : 8;
    if (value?.length < maxLength) {
      formik.setFieldValue('countyCodeValue', value);
    }
  };

  useEffect(() => {
    setCaptchaKey(Date.now());
    captchaRef.current.reset();
  }, [lang]);

  return (
    <form
      className={`${styles.tabContent} ${styles.info}`}
      onSubmit={formik.handleSubmit}
      itemScope
      itemType='https://schema.org/Action'
    >
      <div>
        <Input
          readOnly
          onBlur={() => {
            formik.handleBlur('phoneField');
          }}
          error={formik.touched.phoneField && formik.errors.phoneField}
          onClick={setDeviceModal}
          value={formik.values.phoneField}
          label={t('esim:checkout.inputs.mobile')}
          placeholder={t('esim:checkout.inputs.chooseMobile')}
        />
        <span className={styles.selectError} onClick={setNotInListModal}>
          {t('esim:checkout.inputs.doesNotDevice')}
        </span>
      </div>
      <div>
        <InputWithSelect
          onBlur={formik.handleBlur('phoneNumber')}
          type='tel'
          error={formik.touched.phoneNumber && formik.errors.phoneNumber}
          selected={formik.values.phoneNumberCode.name}
          label={t('esim:checkout.inputs.phoneNumber')}
          placeholder={'XXX XX XX'}
          mask={'999 99 99'}
          options={customerPrefixes}
          value={formik.values.phoneNumber}
          onChange={(value) => formik.setFieldValue('phoneNumber', value)}
          onSelect={(value) => formik.setFieldValue('phoneNumberCode', value)}
          className={styles.customSelect}
        />
      </div>
      <InputWithSelect
        onBlur={formik.handleBlur('countyCodeValue')}
        error={formik.touched.countyCodeValue && formik.errors.countyCodeValue}
        selected={formik.values.countyCode.name}
        label={t('esim:checkout.inputs.seriaLabel')}
        placeholder={''}
        options={serialPrefixes}
        value={formik.values.countyCodeValue}
        onChange={handleCountryCode}
        onSelect={(value) => formik.setFieldValue('countyCode', value)}
        type='number'
        className={styles.customSelect}
      />
      <Input
        onBlur={formik.handleBlur('pin')}
        error={formik.touched.pin && formik.errors.pin}
        type='onlyNumbersLetters'
        onChange={(value) => formik.setFieldValue('pin', value?.toUpperCase())}
        value={formik.values.pin}
        label={t('esim:checkout.inputs.finNumber')}
        placeholder={t('esim:checkout.inputs.addFin')}
        iconClass={styles.pin_input}
        IconRight={InfoCircleRed}
        onClickRightIcon={setPinModal}
        maxLength={7}
      />

      <ReCAPTCHA
        name='g-recaptcha-response'
        sitekey={envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default'}
        onChange={onChange}
        hl={lang}
        key={captchaKey}
        ref={captchaRef}
      />
      <ConditionCheck
        onChange={setTermsModal}
        checked={formik.values.terms}
        formik={formik}
      />
    </form>
  );
};

export default PersonalInfo;
